import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { useAuthStateStore } from '@annunciate/core';
import { TAG_CREATE } from '@annunciate/query/dist/queries/tag';
import { useMutation } from './base';
const getUUID = useAuthStateStore.getState().getUUID;
export const useTagCreateMutation = () => {
    const client = useQueryClient();
    return useMutation(TAG_CREATE, {
        onSuccess: (data) => {
            const tag = data;
            const uuid = getUUID(true);
            const key = ['tag', uuid];
            client.setQueryData(key, (old) => {
                return produce(old || [], (draft) => {
                    const idx = draft.findIndex((t) => t.id === tag.id);
                    if (idx > -1) {
                        draft[idx] = tag;
                    }
                    else {
                        draft.push(tag);
                    }
                });
            });
        },
    }, (data) => data.tag);
};
//# sourceMappingURL=useTagCreateMutation.js.map